export default __webpack_public_path__ + "static/media/Frame 4.a038067f.svg";